module.exports = __webpack_public_path__ + "img/64.56d47657.png";